import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { PageLink } from '@shared/models/page-link/page-link.class';

@Component({
    selector: 'shopbox-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss']
})
export class ItemComponent {
  @ViewChild('item', { static: false}) item: HTMLDivElement;
  @Input() link: PageLink;
  @Input() index: number;
  @Output() linkClickHandle: EventEmitter<number> = new EventEmitter<number>();
  @Input() minItem: boolean = false;

  @Input() set focus(val: boolean) {
    if (val) {
      let element = this.item;
      this.setElementFocus(element);
    } else {
      this.setElementBlur();
    }
  }

  @Input() _activeProgress(val: boolean) {
      this.activeProgress = val;
  }

  activeProgress: boolean = false;

  constructor(
    private _hostElement: ElementRef,
    private _render: Renderer2
  ) { }

  setElementBlur() {
    if (this._hostElement && this._hostElement.nativeElement) {
      this._render.setAttribute(this._hostElement.nativeElement, 'data-focus', 'false');
    }
  }

  setElementFocus(element: any) {
    if (this._hostElement && this._hostElement.nativeElement) {
      this._render.setAttribute(this._hostElement.nativeElement, 'data-focus', 'true');
    }
    if (element) {
      element.nativeElement.focus();
    }
  }

  preventClicking(event: MouseEvent) {
    event.preventDefault();
  }

  isHasSvg(img: string): boolean {
    return img.includes('svg');
  }

}
